export const dbActionTypes = {
  SET_INITIALIZED: 'SET_INITIALIZED',
};
